if (!window.console) {
	//window.console = { log: function(msg){} };
}


$(window).load(function () {
	/**
	 * imgfit
	 */
	$('.imgfit_bg').imgfit({
		align: "c",
		fit: "cover",
		autoResize: false
	});
	$('.imgfit_text').imgfit({
		align: "lt",
		fit: "contain",
		autoResize: false
	});
	$('.imgfit_slider, .imgfit_bg_c').imgfit({
		align: "c",
		fit: "contain",
		autoResize: false
	});
	$('.imgfit_bg_h').imgfit({
		align: "c",
		fit: "height",
		autoResize: false
	});

	/**
	 * resize
	 */
	$(window).on('resize', _.debounce(function () {
		if ($('html').hasClass('js-slide-enable')) $('.l-slide-container').height($(window).height());
		$('.slide-list, .slide-list-item').height($(window).height());
		$('.slide-list-item-container').height($(window).innerHeight() - $('#ms_header').height());
		var _baseW = 1400;
		var _baseH = 878;
		var _w = $('.slide-list-item-container').width() / _baseW;
		var _h = $('.slide-list-item-container').height() / _baseH;
		var _ratio = Math.min(_w, _h);
		$('.slide-list-item-container-inner').width(_baseW * _ratio);
		$('.slide-list-item-container-inner').height(Math.max(_baseH * _ratio, $('.slide-list-item-container').height()));

		// imgfit
		$('.imgfit_bg, .imgfit_bg_c, .imgfit_text, .imgfit_slider, .imgfit_bg_h').each(function () {
			if ($(this).data('imgfit')) $(this).data('imgfit').fit();
		});
	}, 100));
	$(window).trigger('resize');


	/**
	 * Tween
	 */
	// tweenManager
	var tweenManager = new TweenManager({
		el: '.slide-list',
		tweens: tweensArray
	});

	tweenManager.listenTo(tweenManager, 'tween:enable', function (enable) {
		//console.log('enable', enable);
	});

	tweenManager.listenTo(tweenManager, 'scroll:limit:next', function () {
		tweenManager.close();
	});

	// スライダー開閉
	tweenManager.listenTo(tweenManager, 'tween:open', function () {
		TweenMax.to('.l-slide-container',
			0.6,
			{
				height: $(window).height(),
				onStart: function () {
					$('html').removeClass('js-slide-disable');
					$('html').addClass('js-slide-enable');
				},
				onComplete: function () {
					tweenManager.setEnable(true);
					tweenManager.trigger('tween:open:complete');
				},
				ease: Cubic.easeInOut
			}
		);
	});
	tweenManager.listenTo(tweenManager, 'tween:close', function () {
		TweenMax.to('.l-slide-container',
			0.6,
			{
				height: 0,
				onComplete: function () {
					tweenManager.setEnable(false);
					$('html').addClass('js-slide-disable');
					$('html').removeClass('js-slide-enable');
					tweenManager.trigger('tween:close:complete');
				},
				ease: Cubic.easeInOut
			}
		);
	});

	// スライドエリアのホイール処理
	var slideMouseWheelHandler = _.throttle(function(event){
		if(tweenManager.getEnable()){
			if (event.deltaY > 0) {
				tweenManager.prev();
			} else {
				tweenManager.next();
			}
		}
	}, 250);

	$('.l-slide-container').on('mousewheel', function (event) {
		event.preventDefault();
		slideMouseWheelHandler($.Event('mousewheel', { deltaY : event.deltaY }));
	});

	// スライドエリア外のホイール処理
	$('.l-section-container').on('mousewheel', _.throttle(function (event) {
		if ($('html').hasClass('js-slide-disable') && event.deltaY > 0 && $(window).scrollTop() == 0) {
			tweenManager.open();
		}
	}, 250));

	// キーウォッチャー
	$(document).keydown(function (e) {
		if (e.keyCode == 9 || (e.keyCode == 32 && !$('.search .menu .keyword .close')[0])) {
			e.preventDefault();
		}

		// up
		if (e.keyCode == 33 || e.keyCode == 38) {
			if ($('html').hasClass('js-slide-enable') && !(tweenManager.getCurrent().get('sceneId') == '1')) {
				e.preventDefault();
				if (tweenManager.getEnable()) slideMouseWheelHandler($.Event("mousewheel", {deltaY: 1}));
			} else if ($('html').hasClass('js-slide-disable') && $(window).scrollTop() == 0) {
				e.preventDefault();
				$('.l-section-container').trigger($.Event("mousewheel", {deltaY: 1}));
			}
		}

		// down
		if (e.keyCode == 34 || e.keyCode == 40) {
			if ($('html').hasClass('js-slide-enable')) {
				e.preventDefault();
				if (tweenManager.getEnable()) slideMouseWheelHandler($.Event("mousewheel", { deltaY: -1}));
			}
		}
	});


	// サイドナビ処理
	$('.sidenavi-btn').on('click', function (e) {
		e.preventDefault();
		var index = parseInt($(this).data('index'), 10);
		switch (index) {
			case 1:
				if ($('html').hasClass('js-slide-disable')) tweenManager.trigger('tween:open');
				tweenManager.go('1');
				break;
			case 2:
				if ($('html').hasClass('js-slide-disable')) tweenManager.trigger('tween:open');
				tweenManager.go('2-1');
				break;
			case 3:
				if ($('html').hasClass('js-slide-disable')) tweenManager.trigger('tween:open');
				tweenManager.go('3-1');
				break;
			case 4:
				if ($('html').hasClass('js-slide-disable')) tweenManager.trigger('tween:open');
				tweenManager.go('4-1');
				break;
			case 5:
				if ($('html').hasClass('js-slide-enable')) {
					tweenManager.trigger('tween:close');
					tweenManager.listenToOnce(tweenManager, 'tween:close:complete', function () {
						$('html,body').animate({scrollTop: $('#shoesNew').offset().top}, 'normal');
					});
				} else {
					$('html,body').animate({scrollTop: $('#shoesNew').offset().top}, 'normal');
				}
				//tweenManager.go('4-1');
				break;
			case 6:
				if ($('html').hasClass('js-slide-enable')) {
					tweenManager.trigger('tween:close');
					tweenManager.listenToOnce(tweenManager, 'tween:close:complete', function () {
						$('html,body').animate({scrollTop: $('#shoplist').offset().top}, 'normal');
					});
				} else {
					$('html,body').animate({scrollTop: $('#shoplist').offset().top}, 'normal');
				}
				break;
		}
	});
	// ファーストビューの下矢印ボタン
	$('.js-slide-btn-next').on('click', function (e) {
		if (tweenManager.getEnable()) tweenManager.next();
	});

	$('html').addClass('js-slide-enable');
	tweenManager.go('1');
	window.tweenManager = tweenManager;
});

var $item1_slider, item1_slider_obj;

$(function () {
	/*
	// UA
	if (g_browser.SmartPhone || g_browser.Android || g_browser.iPad) {
		location.href = './sp/';
	}
	*/
	
	// shoplist
	shoplist();
	
	// sidenavi
	var sidenav = {
		$nav: null
		, navHeight: 0
		, navTop: 0
		, navStart: 0
		, navEnd: 0
		, navScrollSpeed: 500
		, init: function () {
			var _this = this;
			_this.$nav = $('.sidenavi').show();
			_this.initSize();
			_this.bindEvent();
			_this.resizeWin();
			_this.scrollWin();
			$(window).load(function () {
				_this.initSize();
				_this.resizeWin();
				_this.scrollWin();
			});
		}
		, initSize: function () {
			var _this = this;
			_this.navHeight = _this.$nav.height();
			_this.navStart = 186 + 51 + 40;
			_this.navStart = $(window).height() * 0.5 - _this.navHeight * 0.5;
			_this.navEnd = $('footer').offset().top - _this.navHeight - 40;
		}
		, bindEvent: function () {
			var _this = this;

			$(window).resize(function () {
				_this.resizeWin();
				_this.scrollWin();
			});

			$(window).scroll(function () {
				_this.scrollWin(true);
			});

			$('a', _this.$nav).click(function () {
				var href = $(this).attr('href');
				var top;
				if (href == '#') {
					top = 0;
				} else {
					if (href.substr(0, 1) != '#' || !$(href).length) return;
					var top = $(href).offset().top;
				}
				$('html,body').animate({scrollTop: top}, _this.navScrollSpeed, 'swing');
				return false;
			});
		}
		, resizeWin: function () {
			var _this = this;
			var winHeight = $(window).innerHeight();
			_this.navStart = $(window).height() * 0.5 - _this.navHeight * 0.5;

			if (winHeight > _this.navHeight) {
				_this.navTop = (winHeight - _this.navHeight) / 3;
			} else {
				_this.navTop = 0;
			}
		}
		, scrollWin: function (animate) {
			var _this = this;
			var scroll = $(window).scrollTop();
			var winHeight = $(window).innerHeight();
			_this.navEnd = $('footer').offset().top - _this.navHeight - 40;

			var top = scroll + _this.navTop;
			if (top < _this.navStart) top = _this.navStart;
			if (top > _this.navEnd) top = _this.navEnd;

			if (animate) {
				if (_this.navFading)_this.$nav.stop(true, true);
				_this.$nav.stop(true).animate({top: top});
			} else {
				_this.$nav.css({top: top});
			}
		}
	};
	sidenav.init();

	/**
	 * colorbox
	 */
	$(".js-modal-profile").colorbox({
		innerWidth: '960px',
		innerHeight: '612px',
		opacity: 0.8,
		inline: true,
		closeButton: false,
		href: ".modal-profile",
		onComplete:function(){
			$item1_slider.length && $item1_slider.slick('slickPause');
		},
		onClosed:function(){
			$item1_slider.length && $item1_slider.slick('slickPlay');
		}
	});
	$(".js-modal-outdry").colorbox({
		innerWidth: '1056px',
		innerHeight: '607px',
		opacity: 0.8,
		inline: true,
		closeButton: false,
		href: ".modal-outdry",
		onComplete:function(){
			$item1_slider.length && $item1_slider.slick('slickPause');
		},
		onClosed:function(){
			$item1_slider.length && $item1_slider.slick('slickPlay');
		}
	});
	$('.js-modal-movie').each(function(){
		var href = 'https://www.youtube.com/embed/' + $(this).data('youtubeid') + '?rel=0&autoplay=1';
		$(this).colorbox({
			innerWidth: '990px',
			innerHeight: '604px',
			initialWidth: '990px',
			initialHeight: '604px',
			opacity: 0.8,
			inline: true,
			closeButton: true,
			href: '.modal-movie',
			onOpen:function(){
				$('.modal-movie .modal-movie-movie').html('<iframe frameborder="0" allowfullscreen="" src="'+href+'" width="960" height="540"></iframe>');
			},
			onComplete:function(){
				//$item1_slider.length && $item1_slider.slick('slickPause');
				$item1_slider.length && $item1_slider.slick('unslick');
			},
			onClosed:function(){
				$('.modal-movie .modal-movie-movie').empty();
				//$item1_slider.length && $item1_slider.slick('slickPlay');
				$item1_slider.length && $item1_slider.slick(item1_slider_obj);
			}
		});
	});

	/**
	 * slick
	 */
	$(window).load(function () {
		$('.slider-container').slick({
			//infinite: false,
			//speed: 5000,
			centerPadding: '0px',
			//centerMode: true,
			//adaptiveHeight: true,
			prevArrow: $('.slider-btn-prev'),
			nextArrow: $('.slider-btn-next')
		});
		
		item1_slider_obj = {
			autoplay:true,
			autoplaySpeed:5000,
			easing:'easeInOutQuart',
			speed:1000,
			fade:true
		};
		$item1_slider = $('.slide-list-item1 .slider').slick(item1_slider_obj);

		$(window).trigger('resize');
	});
	
	$('html').addClass('js-slide-enable');
	$('.l-slide-container').height($(window).height());
	$('.slide-list, .slide-list-item').height($(window).height());
	
	// hover animation
	animHover.init();
});

// hover animation
var animHover = {
	target:'.hoverFade'
	,opt:{
		duration:200
		,opacity:0.80
	}
	,init:function(){
		var _this = this;
		$(document)
		.on('mouseenter.animHover', _this.target, function(){
			if($(this).parent('map').length){
				var mapid = $(this).parent('map').attr('name');
				var $target = $('img[usemap="#'+mapid+'"]');
			}else{
				if(g_browser.isIE && g_browser.iev <= 8 && $('img', this).length && !$('img[src$="png"]').length){
					var $target = $('img', this);
				}else{
					var $target = $(this);
				}
			}
			var opt = $.extend(true, {}, _this.opt, {opacity:$(this).data('anim-hover-opacity'),duration:$(this).data('anim-hover-duration')});
			$target.stop(true).fadeTo(opt.duration, opt.opacity);
		})
		.on('mouseleave.animHover', _this.target, function(){
			if($(this).parent('map').length){
				var mapid = $(this).parent('map').attr('name');
				var $target = $('img[usemap="#'+mapid+'"]');
			}else{
				if(g_browser.isIE && g_browser.iev <= 8 && $('img', this).length && !$('img[src$="png"]').length){
					var $target = $('img', this);
				}else{
					var $target = $(this);
				}
			}
			var opt = $.extend(true, {}, _this.opt, {duration:$(this).data('anim-hover-duration')});
			$target.stop(true).fadeTo(opt.duration, 1);
		});
	}
};

//browser ver rev.20160901
var g_browser = (function() {
	var o = {};
	var ua = navigator.userAgent;
	var apn = navigator.appName;
	var apv = navigator.appVersion;
	o.ua = ua;
	o.apn = apn;
	o.apv = apv;
	o.isWin9X = (apv.search(/windows 98/i) > -1);
	o.isIE = (ua.search(/MSIE/) > -1 || ua.search(/Trident/) > -1);
	o.isOpera = (ua.search(/opera/i) > -1);
	if (o.isOpera) o.isIE = false;
	o.isSafari = (apv.search(/safari/i) > -1);
	o.Android = (ua.search(/android/i) > -1);
	o.AndroidMobile = ((ua.search(/android/i) > -1) && (ua.search(/mobile/i) > -1));
	o.AndroidTablet = ((ua.search(/android/i) > -1) && !(ua.search(/mobile/i) > -1));
	o.iPhone = (ua.search(/iphone/i) > -1);
	o.iPod = (ua.search(/ipod/i) > -1);
	o.iPad = (ua.search(/ipad/i) > -1);
	o.iOS = o.iPhone || o.iPod || o.iPad;
	o.isWindowsPhone = ua.search(/windows phone/i) > -1;
	o.SmartPhone = (ua.search(/webkit/i) > -1 && ua.search(/mobile/i) > -1 || o.isWindowsPhone);
	if(o.iPad) o.SmartPhone = false;
	o.isEdge = (ua.search(/Edge/) > -1);
	if(o.isEdge) o.isSafari = false;
	o.iev = -1;
	if (o.isIE) {
		var re = new RegExp('MSIE ([0-9]+[\.0-9]*)');
		var re2 = new RegExp('rv\:([0-9]+[\.0-9]*)');
		if (re.exec(ua) != null || re2.exec(ua) != null) {
			o.iev = parseFloat(RegExp.$1);
		}
	}
	o.Androidv = -1;
	if(o.Android){
		var re = new RegExp('Android ([0-9\.]+)[^0-9\.]');
		if (re.exec(ua) != null){
			o.Androidv = RegExp.$1;
		}
	}
	o.iOSv = -1;
	if(o.iOS){
		var re = new RegExp('OS ([0-9_]+)[^0-9_]');
		if (re.exec(ua) != null){
			o.iOSv = RegExp.$1.replace('_', '.');
		}
	}
	return o;
})();

// shoplist
function shoplist(){
	
	var template = {
		// 地域ブロック
		tmplArea : (function(){
			return '"'+
			'<section id=\\""+area_id+"\\">\\n'+
			'	<h3><span>"+area_name+"</span></h3>\\n'+
			'	<div class=\\"table\\">\\n'+
			'		<table>\\n'+
			'			<thead>\\n'+
			'				<tr>\\n'+
			'"+head_ht+"'+
			'				</tr>\\n'+
			'			</thead>\\n'+
			'			<tbody>\\n'+
			'"+body_ht+"'+
			'			</tbody>\\n'+
			'		</table>\\n'+
			'	</div>\\n'+
			'</section>\\n'+
			'"';
		})()
		// 地域ヘッダー
		,tmplHead : (function(){
			return '"'+
			'					<th scope=\\"col\\">店名</th>\\n'+
			'					<th scope=\\"col\\">住所</th>\\n'+
			'					<th scope=\\"col\\">電話番号</th>\\n'+
			'"+header_items+"'+
			'"';
		})()
		// 地域ヘッダー内アイテム
		,tmplHeadItem : (function(){
			return '"'+
			'					<th scope=\\"col\\" class=\\"item item"+headerId+"\\">"+title+"</th>\\n'+
			'"';
		})()
		// 店舗ブロック
		,tmplBody : (function(){
			return '"'+
			'				<tr>\\n'+
			'				<th scope=\\"row\\">"+name+"</th>\\n'+
			'				<td class=\\"address\\">〒"+zip+"<br>"+pref+address+"</td>\\n'+
			'				<td class=\\"tel\\">"+tel+"</td>\\n'+
			'"+body_items+"'+
			'				</tr>\\n'+
			'"';
		})()
		// 店舗ブロック内アイテム
		,tmplBodyItem : (function(){
			return '"'+
			'				<td class=\\"item item"+recId+"\\"><span class=\\"circle\\">"+item+"</span></td>\\n'+
			'"';
		})()
	};
	
	// Shoplist
	new Shoplist({
		shoplistArea:'#shoplist #shoplistBlock'
		,csv_filename:'shoplist.csv'
		,data_name_col:1	// 店名列
		,data_zip_col:2	// 郵便番号列
		,data_pref_col:3	// 都道府県列
		,data_address_col:4	// 住所列
		,data_tel_col:5	// TEL列
		,data_item_start_col:6	// item開始列
		,tmplArea:template.tmplArea
		,tmplHead:template.tmplHead
		,tmplHeadItem:template.tmplHeadItem
		,tmplBody:template.tmplBody
		,tmplBodyItem:template.tmplBodyItem
		,complete:function(){
			// slideDowm/slideUp
			var duration = !$('html').hasClass('SP') ? 600 : 800;
			$('#shoplist #shoplistBlock h3').on('click', function(){
				var $h3 = $(this);
				if(!$h3.hasClass('open')){
					$h3.addClass('open');
					$h3.next('.table').slideDown({duration:duration, easing:'easeOutQuart'});
				}else{
					$h3.removeClass('open');
					$h3.next('.table').stop(true).slideUp({duration:duration, easing:'easeOutQuart'});
				}
			});
		}
	});
	
}
